import { GalleryPageCmp } from "@customer-gallery/components/GalleryPageCmp";
import { CustomerTypedRoute } from "@customer-gallery/definitions/routeDefinitions";
import React from "react";
const NftGalleryPage: CustomerTypedRoute<"/"> = props => {
  return <GalleryPageCmp {...props} />;
};
export default NftGalleryPage;